__turbopack_context__.v({
  "wrapper": "JourneyBpiLinkBanner-module__CQdmUa__wrapper",
});
